import {
  Box,
  Button,
  Typography,
  Divider,
  TextField,
  IconButton,
  Card,
  Tooltip,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { React, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import sectionApi from "../../api/sectionApi";
import recipeApi from "../../api/recipeApi";
import RecipeModal from "./RecipeModal";
import { toast } from "react-toastify";
import { toastErrorOptions, toastSuccessOptions } from "../../utils/constVals";
import Grow from "@mui/material/Grow";
import PieChartSharpIcon from "@mui/icons-material/PieChartSharp";
import PictureAsPdfSharpIcon from "@mui/icons-material/PictureAsPdfSharp";
import ReceiptSharpIcon from "@mui/icons-material/ReceiptSharp";
import QrCode2SharpIcon from "@mui/icons-material/QrCode2Sharp";
import CategorySharpIcon from "@mui/icons-material/CategorySharp";
import QrCodeSharpIcon from "@mui/icons-material/QrCodeSharp";
import ContentCopySharpIcon from "@mui/icons-material/ContentCopySharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NutritionsFactsLabelVertical from "../Labels/NutritionsFactsLabelVertical";
import LabelWithIndicators from "../Labels/LabelWithIndicators";
import QrModal from "../QrModal";
import DonutModal from "../DonutModal";
import RecipeCartModal from "../RecipeCartModal";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

let timer;
const timeout = 500;

const iconsBarStyles = {
  marginLeft: "5px",
  "&:hover": { color: "red", transition: "0.3s" },
  margin: "7px",
};

const Kanban = (props) => {
  const boardId = props.boardId;
  const [data, setData] = useState([]);
  const [selectedRecipe, setSelectedRecipe] = useState(undefined);
  const [isShown, setIsShown] = useState(false);
  const [isActiveItem, setIsActiveItem] = useState("");
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);
  const onDragEnd = async ({ source, destination }) => {
    if (!destination) return;

    const sourceColIndex = data.findIndex((e) => e.id === source.droppableId);
    const destinationColIndex = data.findIndex(
      (e) => e.id === destination.droppableId
    );
    const sourceCol = data[sourceColIndex];
    const destinationCol = data[destinationColIndex];

    const sourceSectionId = sourceCol.id;
    const destinationSectionId = destinationCol.id;

    const sourceRecipes = [...sourceCol.recipes];
    const destinationRecipes = [...destinationCol.recipes];

    if (source.droppableId !== destination.droppableId) {
      const [removed] = sourceRecipes.splice(source.index, 1);
      destinationRecipes.splice(destination.index, 0, removed);
      data[sourceColIndex].recipes = sourceRecipes;
      data[destinationColIndex].recipes = destinationRecipes;
    } else {
      const [removed] = destinationRecipes.splice(source.index, 1);
      destinationRecipes.splice(destination.index, 0, removed);
      data[destinationColIndex].recipes = destinationRecipes;
    }

    try {
      await recipeApi.updatePosition(boardId, {
        resourcesList: sourceRecipes,
        destinationList: destinationRecipes,
        resourceSectionId: sourceSectionId,
        destinationSectionId: destinationSectionId,
      });
      setData(data);
      toast.success("Recipe Category Updated", toastSuccessOptions);
    } catch (err) {
      toast.error(err, toastErrorOptions);
    }
  };

  const createSection = async () => {
    try {
      const section = await sectionApi.create(boardId);
      setData([...data, section]);
      toast.success("Category Created", toastSuccessOptions);
    } catch (err) {
      toast.error(err, toastErrorOptions);
    }
  };

  const deleteSection = async (sectionId) => {
    try {
      await sectionApi.delete(boardId, sectionId);
      const newData = [...data].filter((e) => e.id !== sectionId);
      setData(newData);
      toast.info("Category Deleted", toastSuccessOptions);
    } catch (err) {
      toast.error(err, toastErrorOptions);
    }
  };

  const updateSectionTitle = async (e, sectionId) => {
    clearTimeout(timer);
    const newTitle = e.target.value;
    const newData = [...data];
    const index = newData.findIndex((e) => e.id === sectionId);
    newData[index].title = newTitle;
    setData(newData);
    timer = setTimeout(async () => {
      try {
        await sectionApi.update(boardId, sectionId, { title: newTitle });
        toast.success("Category Title Changed", toastSuccessOptions);
      } catch (err) {
        alert("error here");
      }
    }, timeout);
  };

  const createRecipe = async (sectionId) => {
    try {
      const recipe = await recipeApi.create(boardId, { sectionId });

      const newData = [...data];
      const index = newData.findIndex((e) => e.id === sectionId);
      newData[index].recipes.unshift(recipe);

      setData(newData);
      toast.success("New Recipe Created", toastSuccessOptions);
    } catch (err) {
      toast.error(err, toastErrorOptions);
    }
  };

  const DuplicateRecipe = async (sectionId, recipeItem) => {
    try {
      const recipe = await recipeApi.duplicate(boardId, {
        sectionId,
        recipeItem,
      });

      const newData = [...data];
      const index = newData.findIndex((e) => e.id === sectionId);
      newData[index].recipes.unshift(recipe);

      setData(newData);
      toast.success("Recipe Duplicated", toastSuccessOptions);
    } catch (err) {
      toast.error(err, toastErrorOptions);
    }
  };

  const onUpdateRecipe = (recipe) => {
    const newData = [...data];
    const sectionIndex = newData.findIndex((e) => e.id === recipe.section.id);
    const recipeIndex = newData[sectionIndex].recipes.findIndex(
      (e) => e.id === recipe.id
    );
    newData[sectionIndex].recipes[recipeIndex] = recipe;
    setData(newData);
  };

  const onDeleteRecipe = async (recipe) => {
    const recipeItem = recipe;
    try {
      await recipeApi.delete(boardId, recipe.id);
      props.onDelete(recipe);
      //setRecipe(undefined)
      toast.info("Recipe Deleted", toastSuccessOptions);
    } catch (err) {
      toast.error(err, toastErrorOptions);
    }
    onUpdateRecipe(recipeItem);
    // alert(recipe.section.id);
    const newData = [...data];
    const sectionIndex = newData.findIndex((e) => e.id === recipe.section.id);
    const recipeIndex = newData[sectionIndex].recipes.findIndex(
      (e) => e.id === recipe.id
    );
    newData[sectionIndex].recipes.splice(recipeIndex, 1);
    setData(newData);
    toast.info("Recipe Deleted", toastSuccessOptions);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [openNutritionFactsLabelModal, setOpenNutritionFactsLabelModal] =
    useState(false);
  const [
    nutritionFactsLabelModalRecipeId,
    setNutritionFactsLabelModalRecipeId,
  ] = useState("");

  const handleOpenNutritionFactsLabelModal = (e) => {
    setNutritionFactsLabelModalRecipeId(e.id);
    setOpenNutritionFactsLabelModal(true);
  };
  const handleCloseNutritionFactsLabelModal = () => {
    setNutritionFactsLabelModalRecipeId("");
    setOpenNutritionFactsLabelModal(false);
  };

  const [
    nutritionIndicatorsModalRecipeId,
    setNutritionIndicatorsModalRecipeId,
  ] = useState("");

  const [openNutritionIndicatorsModal, setOpenNutritionIndicatorsModal] =
    useState(false);
  const handleOpenNutritionIndicatorsModal = (e) => {
    setNutritionIndicatorsModalRecipeId(e.id);
    setOpenNutritionIndicatorsModal(true);
  };
  const handleCloseNutritionIndicatorsModal = () => {
    setNutritionIndicatorsModalRecipeId("");
    setOpenNutritionIndicatorsModal(false);
  };

  const [QrModalRecipeId, setQrModalRecipeId] = useState("");

  const [openQrModal, setopenQrModal] = useState(false);
  const handleOpenQrModal = (e) => {
    setQrModalRecipeId(e.id);
    setopenQrModal(true);
  };
  const handleCloseQrModal = () => {
    setQrModalRecipeId("");
    setopenQrModal(false);
  };

  const [donutChartModalRecipe, setdonutChartModalRecipe] = useState(undefined);

  const [opendonutChartModal, setopendonutChartModal] = useState(false);
  const handleOpendonutChartModal = (recipe) => {
    setdonutChartModalRecipe(recipe);
    setopendonutChartModal(true);
  };
  const handleClosedonutChartModal = () => {
    setdonutChartModalRecipe(undefined);
    setopendonutChartModal(false);
  };

  const [recipeCartModalRecipe, setrecipeCartModalRecipe] = useState(undefined);

  const [openRecipeCartModal, setrecipeCartModal] = useState(false);
  const handleOpenRecipeCartModal = (recipe) => {
    setrecipeCartModalRecipe(recipe);
    setrecipeCartModal(true);
  };
  const handleCloseRecipeCartModal = () => {
    setrecipeCartModalRecipe(undefined);
    setrecipeCartModal(false);
  };
  const [filterSearch, setFilterSearch] = useState("");
  return (
    <>
      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={2}
        alignItems={isMobile ? "stretch" : "center"}
        justifyContent="space-between"
        sx={{ width: "100%", flexWrap: isMobile ? "wrap" : "nowrap" }}
      >
        <Button
          onClick={createSection}
          fullWidth={isMobile}
          variant="contained"
          sx={{
            alignSelf: isMobile ? "stretch" : "flex-start",
            backgroundColor: isMobile ? "#111827" : "#f8fafc",
            color: isMobile ? "#ffffff" : "#0f172a",
            borderRadius: "999px",
            px: isMobile ? 3 : 4,
            py: isMobile ? 1.1 : 1.3,
            fontWeight: 600,
            letterSpacing: 0.2,
            fontSize: isMobile ? "0.95rem" : "1rem",
            whiteSpace: "nowrap",
            border: isMobile ? "none" : "1px solid rgba(99,102,241,0.3)",
            boxShadow: isMobile
              ? "none"
              : "0 12px 25px rgba(15,23,42,0.08)",
            justifyContent: "center",
            "&:hover": {
              backgroundColor: isMobile ? "#0a0f1c" : "#eef2ff",
            },
          }}
        >
          Add Recipes Category
        </Button>
        <Typography
          variant="body2"
          fontWeight="700"
          sx={{
            flexShrink: 0,
            pr: isMobile ? 0 : 2,
            textAlign: isMobile ? "left" : "center",
          }}
        >
          {data.length} Sections
        </Typography>
        <OutlinedInput
          value={filterSearch}
          fullWidth
          onChange={(e) => setFilterSearch(e.target.value)}
          placeholder="Search recipes..."
          size="small"
          startAdornment={
            <InputAdornment position="start">
              <SearchRoundedIcon fontSize="small" />
            </InputAdornment>
          }
          sx={{
            borderRadius: 999,
            backgroundColor: "#fff",
            boxShadow: "0 4px 20px rgba(15,23,42,0.08)",
          }}
        />
      </Stack>
      <Divider sx={{ margin: "10p 0" }} />

      {loading ? (
        <Stack spacing={3}>
          {/* For variant="text", adjust the height via font-size */}
          <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
          {/* For other variants, adjust the size with `width` and `height` */}
          <Skeleton variant="circular" width={100} height={100} />
          <Skeleton variant="rectangular" width={"100%"} height={"20vh"} />
          <Skeleton variant="rounded" width={"100%"} height={"20vh"} />
        </Stack>
      ) : (
        <DragDropContext onDragEnd={onDragEnd}>
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "stretch" : "flex-start",
              width: "100%",
              flexWrap: "wrap",
              overflowX: "visible",
              overflowY: "visible",
              gap: 2,
              pb: 2,
              pr: isMobile ? 0 : 1,
            }}
          >
            {data.map((section) => (
              <Box
                key={section.id}
                sx={{ flex: isMobile ? "1 1 100%" : "0 0 auto" }}
              >
                <Droppable key={section.id} droppableId={section.id}>
                  {(provided) => (
                    <Box
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      sx={{
                        width: isMobile ? "100%" : "310px",
                        padding: "10px",
                        margin: isMobile ? "0 0 16px 0" : "10px",
                        backgroundColor: "white",
                        opacity: "0.85",
                        boxShadow: 10,
                        borderRadius: "0px 30px 0px 30px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: "10px",
                        }}
                      >
                        <TextField
                          value={section.title}
                          onChange={(e) => updateSectionTitle(e, section.id)}
                          placeholder="Untitled"
                          variant="outlined"
                          sx={{
                            flexGrow: 1,
                            "& .MuiOutlinedInput-input": { padding: 1 },
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "unset",
                            },
                            "& .MuiOutlinedInput-root": { fontSize: "0.8rem" },
                          }}
                        />
                        <IconButton
                          variant="outlined"
                          size="small"
                          sx={{
                            color: "gray",
                            "&:hover": { color: "green" },
                          }}
                          onClick={() => createRecipe(section.id)}
                        >
                          <AddOutlinedIcon />
                        </IconButton>

                     <IconButton
  variant="outlined"
  size="small"
  sx={{
    color: "gray",
    "&:hover": { color: "red" },
  }}
  onClick={(e) => {
    e.preventDefault();
    const toastId = toast(
      <div>
        <div style={{ marginBottom: '10px' }}>Delete this section and all its recipes?</div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={() => {
              toast.dismiss(toastId);
              deleteSection(section.id);
            }}
            style={{
              padding: '5px 10px',
              background: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Delete
          </button>
          <button
            onClick={() => toast.dismiss(toastId)}
            style={{
              padding: '5px 10px',
              background: '#e0e0e0',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        closeButton: false,
        closeOnClick: false,
        draggable: false,
        style: { minWidth: '300px' }
      }
    );
  }}
>
  <DeleteOutlinedIcon />
</IconButton>
                      </Box>
                      {/* Recipes */}
                      {section.recipes.map((recipe, index) => (
                        <Draggable
                          key={recipe.id}
                          draggableId={recipe.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <Card
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              sx={{
                                padding: "10px",
                                marginBottom: "10px",
                                cursor: snapshot.isDragging
                                  ? "grab"
                                  : "pointer!important",
                                boxShadow: 1,
                                borderRadius: "0px 20px 0px 20px",
                                "&:hover": {
                                  backgroundColor: "#E5E4E2",
                                  transition: "0.5s",
                                  boxShadow: 10,
                                },
                              }}
                              className={`${
                                recipe.title
                                  .toLowerCase()
                                  .includes(filterSearch.toLowerCase())
                                  ? ""
                                  : "hidden"
                              }`}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                                onClick={() => setSelectedRecipe(recipe)}
                              >
                                <Typography variant="body2">
                                  {recipe.title === ""
                                    ? "Untitled"
                                    : recipe.title}
                                </Typography>
                                <GridViewOutlinedIcon
                                  onMouseEnter={(e) => {
                                    setIsActiveItem(recipe.id);
                                    setIsShown(true);
                                  }}
                                  aria-owns={
                                    anchorEl ? "simple-menu" : undefined
                                  }
                                  aria-haspopup="true"
                                  onMouseOver={(e) =>
                                    setAnchorEl(e.currentTarget)
                                  }
                                  sx={{
                                    color: "gray ",
                                  }}
                                ></GridViewOutlinedIcon>
                              </Box>

                              {isShown && isActiveItem === recipe.id && (
                                <Menu
                                  id="basic-menu"
                                  anchorEl={anchorEl}
                                  open={Boolean(anchorEl)}
                                  MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                    onMouseLeave: () => {
                                      setAnchorEl(null);
                                    },
                                  }}
                                  sx={{
                                    "& .MuiList-root": {
                                      borderRadius: 10,
                                      padding: 0,
                                    },
                                    "& .MuiPaper-root": {
                                      borderRadius: 10,
                                      padding: 0,
                                    },
                                    "& .MuiButtonBase-root": {
                                      borderRadius: 10,
                                      backgroundColor: "white !important",
                                    },
                                  }}
                                  onClick={(e) => {
                                    setAnchorEl(null);
                                  }}
                                >
                                  <MenuItem>
                                    <Grow
                                      in={isShown}
                                      {...(isActiveItem
                                        ? { timeout: 1000 }
                                        : {})}
                                    >
                                      <Box
                                        sx={{
                                          marginTop: "10px",
                                          flexWrap: "wrap",
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "120px",
                                        }}
                                      >
                                        <Tooltip
                                          title="Analysis"
                                          placement="left"
                                          arrow
                                        >
                                          <PieChartSharpIcon
                                            onClick={(e) => {
                                              setdonutChartModalRecipe(
                                                undefined
                                              );
                                              handleOpendonutChartModal(recipe);
                                            }}
                                            sx={iconsBarStyles}
                                          ></PieChartSharpIcon>
                                        </Tooltip>
                                        {/* 
                                        <Tooltip
                                          title="Download Recipe as PDF"
                                          placement="top"
                                          arrow
                                        >
                                          <PictureAsPdfSharpIcon
                                            onClick={(e) => {
                                              setSelectedRecipe();
                                              e.preventDefault();

                                              alert(recipe.id);
                                            }}
                                            sx={iconsBarStyles}
                                          ></PictureAsPdfSharpIcon>
                                        </Tooltip> */}

                                        <Tooltip
                                          title="Download Recipe as Label"
                                          placement="top"
                                          arrow
                                        >
                                          <ReceiptSharpIcon
                                            onClick={(e) => {
                                              handleOpenRecipeCartModal(recipe);
                                            }}
                                            sx={iconsBarStyles}
                                          ></ReceiptSharpIcon>
                                        </Tooltip>
                                        <Tooltip
                                          title="Food Item Label QR"
                                          placement="right"
                                          arrow
                                        >
                                          <QrCode2SharpIcon
                                            onClick={(e) => {
                                              handleOpenQrModal(recipe);
                                            }}
                                            sx={iconsBarStyles}
                                          ></QrCode2SharpIcon>
                                        </Tooltip>
                                        <Tooltip
                                          title="Nutritional Labels"
                                          placement="left"
                                          arrow
                                        >
                                          <CategorySharpIcon
                                            onClick={(e) => {
                                              e.preventDefault();

                                              handleOpenNutritionIndicatorsModal(
                                                recipe
                                              );
                                            }}
                                            sx={iconsBarStyles}
                                          ></CategorySharpIcon>
                                        </Tooltip>

                                        <Tooltip
                                          title="Nutrional Facts Label"
                                          placement="bottom"
                                          arrow
                                        >
                                          <QrCodeSharpIcon
                                            onClick={(e) => {
                                              e.preventDefault();
                                              // setSelectedRecipe();

                                              handleOpenNutritionFactsLabelModal(
                                                recipe
                                              );

                                              // alert(recipe.id);
                                            }}
                                            sx={iconsBarStyles}
                                          ></QrCodeSharpIcon>
                                        </Tooltip>

                                        <Tooltip
                                          title="Duplicate Recipe"
                                          placement="right-end"
                                          arrow
                                        >
                                          <ContentCopySharpIcon
                                            onClick={(e) => {
                                              setSelectedRecipe();
                                              e.preventDefault();
                                              DuplicateRecipe(
                                                section.id,
                                                recipe
                                              );
                                            }}
                                            sx={iconsBarStyles}
                                          ></ContentCopySharpIcon>
                                        </Tooltip>

                                        <Tooltip
                                          title="Edit Recipe"
                                          placement="bottom"
                                          arrow
                                        >
                                          <EditSharpIcon
                                            onClick={() =>
                                              setSelectedRecipe(recipe)
                                            }
                                            sx={iconsBarStyles}
                                          ></EditSharpIcon>
                                        </Tooltip>
                                        <Tooltip title="Delete Recipe" placement="right" arrow>
  <DeleteOutlineSharpIcon
    onClick={(e) => {
      e.preventDefault();
      recipe.section.id = section.id;
      // Show confirmation toast
      const toastId = toast(
        <div>
          <div style={{ marginBottom: '10px' }}>Delete "{recipe.title}"?</div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              onClick={() => {
                toast.dismiss(toastId);
                // Proceed with deletion
                onDeleteRecipe(recipe);
              }}
              style={{
                padding: '5px 10px',
                background: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Confirm
            </button>
            <button
              onClick={() => toast.dismiss(toastId)}
              style={{
                padding: '5px 10px',
                background: '#e0e0e0',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
          </div>
        </div>,
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          closeButton: false,
          closeOnClick: false,
          draggable: false,
          style: { minWidth: '300px' }
        }
      );
    }}
    sx={{
      color: 'text.secondary',
      cursor: 'pointer',
      '&:hover': { color: 'error.main' }
    }}
  />
</Tooltip>
                                      </Box>
                                    </Grow>
                                  </MenuItem>
                                </Menu>
                              )}
                            </Card>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </Box>
                  )}
                </Droppable>
              </Box>
            ))}
          </Box>
        </DragDropContext>
      )}
      <RecipeModal
        recipe={selectedRecipe}
        boardId={boardId}
        onClose={() => {
          setSelectedRecipe(undefined);
        }}
        onUpdate={onUpdateRecipe}
        closeModalBtn={(e) => setSelectedRecipe(undefined)}
      />
      <NutritionsFactsLabelVertical
        recipeId={nutritionFactsLabelModalRecipeId}
        open={openNutritionFactsLabelModal}
        onClose={handleCloseNutritionFactsLabelModal}
      />
      <LabelWithIndicators
        recipeId={nutritionIndicatorsModalRecipeId}
        open={openNutritionIndicatorsModal}
        onClose={handleCloseNutritionIndicatorsModal}
      />
      <QrModal
        recipeId={QrModalRecipeId}
        open={openQrModal}
        onClose={handleCloseQrModal}
      ></QrModal>
      <DonutModal
        recipe={donutChartModalRecipe}
        open={opendonutChartModal}
        onClose={handleClosedonutChartModal}
      ></DonutModal>
      <RecipeCartModal
        recipeId={recipeCartModalRecipe}
        open={openRecipeCartModal}
        onClose={handleCloseRecipeCartModal}
        boardId={boardId}
      ></RecipeCartModal>
    </>
  );
};

export default Kanban;
